(function( $ ){

	var pluginName = 'clock';
	
	// defaults
	var defaults = {
    	canvasWidth: 150,
    	canvasHeight: 150,
    	clockSize: 130,
    	bgColor: '#000',
    	clockFaceColor: '#000',
    	outerStrokeColor: '#fff',
    	outerStrokeWidth: 2,
    	centerPinColor: '#fff',
    	centerPinWidth: 4,
    	hourTickColor: '#fff',
    	hourTickWidth: 2,
    	minuteTickColor: '#fff',
    	minuteTickWidth: 1,
    	secondHandColor: '#6ac39b',
    	secondHandWidth: 1,
    	minuteHandColor: '#fff',
    	minuteHandWidth: 2,
    	hourHandColor: '#fff',
    	hourHandWidth: 2,
    	timezone: 'America/Vancouver'
	};
	

    function Clock( element, options ) {
        this.element = element;

        this.settings = $.extend( {}, defaults, options) ;
                
        this.init();
    }

    Clock.prototype.init = function () {
		
		// override certain settings with data-attr if provided
		if ( $(this.element).data( 'timezone' ) ) {
			this.settings.timezone = $(this.element).data( 'timezone' );
		}

		// wrapper style
		$(this.element).width( this.settings.canvasWidth );
		$(this.element).height( this.settings.canvasHeight );

		this.clock = {};
		// create canvas
		this.clock.cvs = $('<canvas width="'+(this.settings.canvasWidth * 2)+'" height="'+(this.settings.canvasHeight * 2)+'" />');
		this.clock.cvs.width( this.settings.canvasWidth );
		this.clock.cvs.height( this.settings.canvasHeight );
		$(this.element).append( this.clock.cvs );
	
		// canvas contexts
		this.clock.ctx = this.clock.cvs.get( 0 ).getContext( '2d' );
		
		//var self = this;
		//self.showClock();
		setInterval(this.showClock.bind(this), 1000);
    };
	
	Clock.prototype.showClock = function() {
		
		this.clock.date = moment().tz(this.settings.timezone);
		
		this.clock.ctx.clearRect(0, 0, this.settings.canvasWidth * 2, this.settings.canvasHeight * 2);        
		// Set bg color
		this.clock.ctx.fillStyle = this.settings.bgColor;
		this.clock.ctx.fillRect(0, 0, this.settings.canvasWidth * 2, this.settings.canvasHeight * 2);

		this.outerDial();
		this.hourTicks();
		this.minuteTicks();

		this.showHours();
		this.showMinutes();
		this.showSeconds();
		
	};
	
	Clock.prototype.outerDial = function() {
		this.clock.ctx.save();
		
		this.clock.ctx.fillStyle = this.settings.clockFaceColor;
		this.clock.ctx.strokeStyle = this.settings.outerStrokeColor;
		this.clock.ctx.lineWidth = this.settings.outerStrokeWidth * 2;
		
		this.clock.ctx.beginPath();
		this.clock.ctx.arc(this.settings.canvasWidth, this.settings.canvasHeight, this.settings.clockSize, 0, Math.PI * 2);
		this.clock.ctx.fill();
		if(this.settings.outerStrokeWidth){
			this.clock.ctx.stroke();
		}
		
		this.clock.ctx.restore();
	};

	Clock.prototype.hourTicks = function() {
		for (var i = 0; i < 12; i++) {
			var angle = (i - 3) * (Math.PI * 2) / 12;
			
			var x1 = this.settings.canvasWidth + Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95);
			var y1 = this.settings.canvasHeight + Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95);
			var x2 = this.settings.canvasWidth + Math.cos(angle) * (this.settings.clockSize * 0.8);
			var y2 = this.settings.canvasHeight + Math.sin(angle) * (this.settings.clockSize * 0.8);

			this.clock.ctx.save();
			
			this.clock.ctx.strokeStyle = this.settings.hourTickColor;
			this.clock.ctx.lineWidth = this.settings.hourTickWidth * 2;

			this.clock.ctx.beginPath();
			this.clock.ctx.moveTo(x1, y1);
			this.clock.ctx.lineTo(x2, y2);
			if(this.settings.hourTickWidth){
				this.clock.ctx.stroke();
			}
			
			this.clock.ctx.restore();
		}
	};

	Clock.prototype.minuteTicks = function() {
		for (var i = 0; i < 60; i++) {
			var angle = (i - 3) * (Math.PI * 2) / 60;

			var x1 = this.settings.canvasWidth + Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95);
			var y1 = this.settings.canvasHeight + Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95);
			var x2 = this.settings.canvasWidth + Math.cos(angle) * (this.settings.clockSize * 0.875);
			var y2 = this.settings.canvasHeight + Math.sin(angle) * (this.settings.clockSize * 0.875);

			this.clock.ctx.save();
			
			this.clock.ctx.strokeStyle = this.settings.minuteTickColor;
			this.clock.ctx.lineWidth = this.settings.minuteTickWidth * 2;
			
			this.clock.ctx.beginPath();
			this.clock.ctx.moveTo(x1, y1);
			this.clock.ctx.lineTo(x2, y2);
			if(this.settings.minuteTickWidth){
				this.clock.ctx.stroke();
			}
			
			this.clock.ctx.restore();
		}
	};

	Clock.prototype.showHours = function() {
		var hour = this.clock.date.hours();
		var min = this.clock.date.minutes();
		var angle = ((Math.PI * 2) * ((hour * 5 + (min / 60) * 5) / 60)) - ((Math.PI * 2) / 4);
		
		this.clock.ctx.save();
			
		this.clock.ctx.strokeStyle = this.settings.hourHandColor;
		this.clock.ctx.fillStyle = this.settings.hourHandColor;
		this.clock.ctx.lineWidth = this.settings.hourHandWidth * 2;

		this.clock.ctx.beginPath();
		// hand
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);
		this.clock.ctx.lineTo((this.settings.canvasWidth + Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.5)), this.settings.canvasHeight + Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.5));
		// tail
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);
		this.clock.ctx.lineTo((this.settings.canvasWidth - Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15)), this.settings.canvasHeight - Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15));
		this.clock.ctx.stroke();
		// center
		this.clock.ctx.beginPath();
		this.clock.ctx.arc(this.settings.canvasWidth, this.settings.canvasHeight, this.settings.hourHandWidth * 4, 0, Math.PI * 2);
		this.clock.ctx.fill();

		this.clock.ctx.restore();
	};

	Clock.prototype.showMinutes = function() {
		var min = this.clock.date.minutes();
		var angle = ((Math.PI * 2) * (min / 60)) - ((Math.PI * 2) / 4);
		
		this.clock.ctx.save();
			
		this.clock.ctx.strokeStyle = this.settings.minuteHandColor;
		this.clock.ctx.fillStyle = this.settings.minuteHandColor;
		this.clock.ctx.lineWidth = this.settings.minuteHandWidth * 2;

		this.clock.ctx.beginPath();
		// hand
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);
		this.clock.ctx.lineTo((this.settings.canvasWidth + Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.75)), this.settings.canvasHeight + Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.75));
		// tail
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);
		this.clock.ctx.lineTo((this.settings.canvasWidth - Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15)), this.settings.canvasHeight - Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15));
		this.clock.ctx.stroke();
		// center
		this.clock.ctx.beginPath();
		this.clock.ctx.arc(this.settings.canvasWidth, this.settings.canvasHeight, this.settings.minuteHandWidth * 4, 0, Math.PI * 2);
		this.clock.ctx.fill();

		this.clock.ctx.restore();
	};

	Clock.prototype.showSeconds = function() {
		var sec = this.clock.date.seconds();
		var angle = ((Math.PI * 2) * (sec / 60)) - ((Math.PI * 2) / 4);
		
		this.clock.ctx.save();
			
		this.clock.ctx.strokeStyle = this.settings.secondHandColor;
		this.clock.ctx.fillStyle = this.settings.secondHandColor;
		this.clock.ctx.lineWidth = this.settings.secondHandWidth * 2;

		this.clock.ctx.beginPath();
		// hand
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);   
		this.clock.ctx.lineTo((this.settings.canvasWidth + Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95)), this.settings.canvasHeight + Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.95));
		// tail
		this.clock.ctx.moveTo(this.settings.canvasWidth, this.settings.canvasHeight);
		this.clock.ctx.lineTo((this.settings.canvasWidth - Math.cos(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15)), this.settings.canvasHeight - Math.sin(angle) * ((this.settings.clockSize - this.settings.outerStrokeWidth) * 0.15));
		this.clock.ctx.stroke();
		// center
		this.clock.ctx.beginPath();
		this.clock.ctx.arc(this.settings.canvasWidth, this.settings.canvasHeight, this.settings.secondHandWidth * 4, 0, Math.PI * 2);
		this.clock.ctx.fill();

		this.clock.ctx.restore();
	};
	

	$.fn.clock = function(options) {
        return this.each(function () {
            if (!$.data(this, 'plugin_' + pluginName)) {
                $.data(this, 'plugin_' + pluginName, new Clock( this, options ));
            }
        });
	};

})( jQuery );